import React from "react";
import Card from "../../../molecules/Card/Card";
import Link from "../../../atoms/Link/Link";
import "./NextSteps.scss";
import { CardThemes } from "../../../molecules/Card/Card.types";

type Strength = { name: string; link: string }[];

type NextStepsData = {
  title: string;
  html_content: string[];
  high_strength: Strength;
  medium_strength: Strength;
  high_expected: Strength;
  medium_expected: Strength;
  low_expected: Strength;
  medium_weakness: Strength;
  low_weakness: Strength;
  invalid: Strength;
};

type NextStepsProps = {
  data: NextStepsData;
};

const StrengthList = ({
  title,
  strengths,
  theme,
}: {
  title: string;
  strengths: Strength;
  theme: CardThemes;
}) => {
  if (strengths.length === 0) return null;

  return (
    <Card title={title} theme={theme}>
      <ul style={{ listStyle: "none", margin: 0, padding: 0 }}>
        {strengths.map((strength) => (
          <li key={strength.name} style={{ marginBottom: "0.5rem" }}>
            <Link target="_blank" to={strength.link}>
              {strength.name}
            </Link>
          </li>
        ))}
      </ul>
    </Card>
  );
};

const NextSteps = ({ data }: NextStepsProps) => {
  return (
    <div className="container">
      <StrengthList
        title="Strengths"
        strengths={[...data.high_strength, ...data.medium_strength]}
        theme={CardThemes.reports_strength}
      />

      <StrengthList
        title="High Expected"
        strengths={data.high_expected}
        theme={CardThemes.reports_expected}
      />
      <StrengthList
        title="Medium Expected"
        strengths={data.medium_expected}
        theme={CardThemes.reports_expected}
      />
      <StrengthList
        title="Low Expected"
        strengths={data.low_expected}
        theme={CardThemes.reports_expected}
      />
      <StrengthList
        title="Skills to Support/Invalid"
        strengths={[
          ...data.medium_weakness,
          ...data.low_weakness,
          ...data.invalid,
        ]}
        theme={CardThemes.reports_weaknesses}
      />
    </div>
  );
};

export default NextSteps;
